var render = function render(){
  var _vm$error$validationM, _vm$error, _vm$error$validationM2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "opacity": "0",
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key, Object.assign({}, _vm.error.validationMessages, {
    package: _vm.$t(`package.type.${(_vm$error$validationM = _vm.error.validationMessages) === null || _vm$error$validationM === void 0 ? void 0 : _vm$error$validationM.package}`)
  }))) + " ")]) : _vm._e(), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', [_c('form-input', {
    attrs: {
      "id": "invite-email",
      "label": _vm.$t('invite.email'),
      "state": _vm.getState('email'),
      "validation-messages": (_vm$error = _vm.error) === null || _vm$error === void 0 ? void 0 : (_vm$error$validationM2 = _vm$error.validationMessages) === null || _vm$error$validationM2 === void 0 ? void 0 : _vm$error$validationM2.email
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.email.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('invite.email')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.email.email ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.email')) + " ")]) : _vm._e(), !_vm.$v.formData.email.localPartMaxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.email')) + " ")]) : _vm._e(), !_vm.$v.formData.email.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('signup.form.email'),
          max: _vm.$v.formData.email.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.email.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.email, "$model", $$v);
      },
      expression: "$v.formData.email.$model"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mt-1"
  }, [_c('b-col', {
    staticClass: "pr-2"
  }, [_c('b-button', {
    staticClass: "modal-button modal-button-back w-100",
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('back')) + " ")])], 1), _c('b-col', {
    staticClass: "pl-2"
  }, [_c('b-button', {
    staticClass: "modal-button w-100",
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.loading || !_vm.$v.formData.email.$dirty
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('invite.title')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }